"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IfAnonymousUser = void 0;
var _useToken = require("./useToken");
const IfAnonymousUser = ({
  children
}) => {
  const {
    isAnonymousUser
  } = (0, _useToken.useToken)();
  if (isAnonymousUser) {
    return children;
  }
  return null;
};
exports.IfAnonymousUser = IfAnonymousUser;
